module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"no_orders_to_review":"沒有可撰寫評論的訂單。","confirm_cancel_review":"確定要取消撰寫評論嗎？取消後已輸入的內容將全部刪除。"}}')
  delete Component.options._Ctor
}
